export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
});

export const formatCurrency = (amount: number, currency?: string): string =>
    currency
        ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency,
              minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
          }).format(amount)
        : currencyFormatter.format(amount);

export const formatCompactCurrency = (amount: number, currency: string): string =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        notation: 'compact',
        maximumFractionDigits: 1,
    }).format(amount);

export const formatPercentage = (value: number): string => `${value.toFixed(1)}%`;

export const formatAnalyticsDate = (date: Date): string => {
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
};
